export class ApplicationError extends Error {
  public constructor(
    public message = "Неизвестная ошибка",
    public code = "666"
  ) {
    super(message);

    this.name = "ApplicationError";
  }
}
